import {
  Injectable,
  ModuleWithProviders,
  NgModule,
  inject,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EadminComponent } from './e-admin.component';
import { environment } from './environment';
import { MaintenanceTemplateComponent } from './maintenance-template/maintenance-template.component';

@Injectable()
export class EnvironmentHolder {
  public env = inject(environment);
}

@NgModule({
  declarations: [EadminComponent, MaintenanceTemplateComponent],
  imports: [BrowserModule],
  exports: [EadminComponent, MaintenanceTemplateComponent],
  providers: [EnvironmentHolder],
})
export class EadminModule {
  public static forRoot(env): ModuleWithProviders<EadminModule> {
    return {
      ngModule: EadminModule,
      providers: [{ provide: environment, useValue: env }],
    };
  }
}
